export const LOCAL_STORAGE_KEYS = {
    TOKEN: "__authToken",
    REFRESH_TOKEN: "__refreshToken",
}

export const ROUTES = {
    MAIN: '/',
    USER_LIST: 'users',
    ADMIN_LIST: 'admins',
    USER_DETAIL: 'users/:id',
    ADMIN_DETAIL: 'admins/:id',
    /*  DASHBOARD: '/dashboard',
     AFFILIATE: '/affiliate',
     MANAGEUSER: '/manageuser',
     MANAGEBRAND: '/managebrand' */
}
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const PAGE_SIZE_OPTIONS = [10, 20, 50];
export const DEFAULT_PAGINATION = {
    page: 1,
    pageSize: 10,
    total: 0,
};

export const SORT_TYPE = {
    ASC: 'asc',
    DESC: 'desc',
}

